import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/privacy.scss";

const questions = [
  ["How do I choose the right routine?", "Start with your current hair texture and main goal: balance, moisture, volume, color care or definition. Each product page lists the best use, texture and key ingredients. If you are still unsure, email our care team with a short description of your hair and routine."],
  ["Are the formulas suitable for color-treated hair?", "Products marked Color-safe are designed for color-treated hair. Always review the full product details and the label you receive, and ask your stylist if your color service requires a specific aftercare plan."],
  ["How much is shipping?", `Tracked shipping is a fixed ${siteConfig.currencySymbol}${siteConfig.shippingFlatRate} per order. The available destination and estimated delivery timing appear at checkout before you continue to payment.`],
  ["When will my order be prepared?", `Orders normally leave our studio within ${siteConfig.policies.dispatchTime}. Busy periods or address checks may add time, and we will contact you by email if a material delay affects your order.`],
  ["Can I change or cancel an order?", "Email us as soon as possible with your order number. Fulfillment can begin quickly, so a change or cancellation is not guaranteed after payment has been completed."],
  ["What is the return window?", `Contact us within ${siteConfig.policies.returnWindow} days of delivery before returning an item. Eligible personal-care products must be unused, unopened and in their original packaging unless they are faulty.`],
  ["Where are payment details entered?", "Card and wallet details are entered only on the secure hosted payment page opened after you submit the checkout information form. rumnwillow does not collect card numbers on its own checkout page."],
  ["How can I contact customer care?", `Email ${siteConfig.contact.email}. Our team normally replies during ${siteConfig.contact.hours}; include the email used at checkout and your order number for order questions.`],
];

function FAQs() {
  return (
    <main className="privacy policy-page">
      <header className="policy-page__hero">
        <p className="policy-page__kicker">Customer care</p>
        <h1>Frequently asked questions</h1>
        <p>Quick guidance on products, ordering, delivery, payment and returns.</p>
      </header>
      <div className="policy-page__layout">
        <nav className="policy-page__nav" aria-label="FAQ categories">
          <span>Helpful links</span>
          <Link to="/shipping">Shipping</Link><Link to="/returns">Returns</Link>
          <Link to="/privacy">Privacy</Link><Link to="/contact">Contact</Link>
        </nav>
        <article className="policy-page__content">
          <section className="policy-page__lead"><p>These answers cover the most common questions. For help with a specific order, contact us using the checkout email address.</p></section>
          {questions.map(([question, answer], index) => (
            <section key={question}>
              <p className="policy-page__number">{String(index + 1).padStart(2, "0")}</p>
              <h2>{question}</h2><p>{answer}</p>
            </section>
          ))}
        </article>
      </div>
    </main>
  );
}

export default FAQs;
